import { Link } from 'react-router-dom';
import { styled } from 'ui';

const commonStyles = {
  color: 'inherit',
  cursor: 'pointer',
  display: 'block',
  height: '100%',
  textDecoration: 'none',
};

export const StyledLink = styled(Link)(commonStyles);

export const StyledAnchor = styled('a')(commonStyles);
